import { fileExtension, fileTypeIdentity, fileTypeLabel, formatFileSize, formatUploadedDate, previewKindFor, uploadedSortValue } from '@features/Attachments/utils/fileFormatting';
/**
 * Enriches one API row with the display/filter/sort values the surface needs.
 *
 * `name` and `fileName` are the same value here — the serializer aliases both from
 * `attachment_file_name`, because `subcontractor_documents` has no `name` column and this screen
 * has never offered a rename.
 */
export function toSubcontractorDocumentRow(api, translateFn) {
    var _a, _b, _c, _d, _e, _f;
    const name = (_a = api.name) !== null && _a !== void 0 ? _a : '';
    const typeSource = ((_b = api.fileName) === null || _b === void 0 ? void 0 : _b.trim()) || name;
    const createdAt = (_c = api.createdAt) !== null && _c !== void 0 ? _c : '';
    return {
        id: api.id,
        name,
        createdAt,
        uploadedLabel: createdAt ? formatUploadedDate(createdAt) : '',
        uploadedSortValue: createdAt ? uploadedSortValue(createdAt) : 0,
        sizeBytes: (_d = api.fileSize) !== null && _d !== void 0 ? _d : 0,
        // A row whose stored file went missing reports no size. "0 Bytes" would be a statement about
        // its size, and a false one.
        sizeLabel: api.fileSize == null ? '' : formatFileSize(api.fileSize),
        uploaderName: (_e = api.uploaderName) !== null && _e !== void 0 ? _e : '',
        directUpload: api.directUpload,
        typeLabel: fileTypeLabel(typeSource, translateFn),
        typeFilterValue: fileTypeIdentity(typeSource),
        previewKind: previewKindFor(typeSource),
        extension: fileExtension(typeSource),
        url: (_f = api.url) !== null && _f !== void 0 ? _f : ''
    };
}
